export default "__VITE_ASSET__d17abf68__"